export default __webpack_public_path__ + "static/media/OOX-Logo-Long-Teal.99db607d.png";